import {useContext} from 'react';

import {DetailsPanelContext} from '../contexts/DetailsPanelContext';

export const useDetailsPanelStore = () => useContext(DetailsPanelContext);
